import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function Settings({ children }) {
    const { hideSettings } = useBoundContext()
    return !hideSettings && children
}
